import { render, staticRenderFns } from "./EditRatesModal.vue?vue&type=template&id=0549e860&scoped=true"
import script from "./EditRatesModal.vue?vue&type=script&lang=js"
export * from "./EditRatesModal.vue?vue&type=script&lang=js"
import style0 from "./EditRatesModal.vue?vue&type=style&index=0&id=0549e860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0549e860",
  null
  
)

export default component.exports